import { render } from "./PageHome.vue?vue&type=template&id=1006994c&scoped=true"
import script from "./PageHome.vue?vue&type=script&lang=js"
export * from "./PageHome.vue?vue&type=script&lang=js"

import "./PageHome.vue?vue&type=style&index=0&id=1006994c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1006994c"]])

export default __exports__